import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: absolute;
  bottom: 48px;
  background-color: #001;
  max-height: 300px;
  width: calc(100% - 170px);
  box-shadow: inset 0 0 5px 5px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;

  &.show {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const Header = styled.div`
  padding: 3px 10px;
  opacity: 0.3;
  border-bottom: 1px solid #aaa;
  font-size: 13px;
`;

export const Suggestions = styled.div`
  display: flex;
  flex-direction: column-reverse;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Suggestion = styled.div`
  font-size: 13px;
  padding: 3px 10px;
  color: #999;
  cursor: pointer;

  span {
    color: #556;
    width: 55px;
    display: inline-block;
    font-family: monospace;
  }

  &:hover {
    color: gold;
  }

  &:nth-child(odd) {
    background-color: rgba(225, 225, 255, 0.1);
  }

  &.selected {
    background-color: #0e4296;
    color: white;
  }
`;
